import Emitter from "./Emitter";

export default class LobbyLoadEnd extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitTop({ wpgaction: "lobbyLoadEnd" });
        this.emitParent({ wpgaction: "lobbyLoadEnd.parent" });
        this.emitiOS({ wpgaction: "lobbyLoadEnd" });
    }
}
